import greenNewLogo from '~assets/papa-johns-logo-new-green.svg';
import whiteNewLogo from '~assets/papa-johns-logo-new-white.svg';

export const logoImage = greenNewLogo;

export const whiteLogo = whiteNewLogo;
